export enum LocalstorageKey {
    PLACE_CACHE = 'landing_place_cache',
    PLACE_KEY = 'landing_place_key'
}
